import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box } from '@mui/material';

export default function TablaConsolidado({ titulo, tipo, catalogo, datosPlanos = [] }) {
  const { columnas, niveles } = catalogo;
  const totalFilasTipo = niveles.reduce((acc, nivel) => acc + nivel.grados.length + 1, 0);

  const dataSegura = Array.isArray(datosPlanos) ? datosPlanos : [];

  const obtenerConteo = (nombreNivel, descGrado, siglaArea) => {
    const match = dataSegura.find(d =>
      d.nivel === nombreNivel &&
      String(d.grado) === String(descGrado) &&
      d.area === siglaArea
    );
    return match ? match.total : 0;
  };

  const totalesGlobales = {};
  columnas.forEach(c => totalesGlobales[c] = 0);
  let totalAbsoluto = 0;

  niveles.forEach(nivel => {
    nivel.grados.forEach(grado => {
      columnas.forEach(col => {
        const valor = obtenerConteo(nivel.nombre, grado, col);
        totalesGlobales[col] += valor;
        totalAbsoluto += valor;
      });
    });
  });

  return (
    <Box sx={{ mb: 6 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>{titulo}</Typography>

      <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2 }}>
        <Table size="small">

          <TableHead sx={{ bgcolor: '#9f9f9f' }}>
            <TableRow>
              <TableCell align="center" rowSpan={2} sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>TIPO</TableCell>
              <TableCell align="center" rowSpan={2} sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>NIVEL</TableCell>
              <TableCell align="center" rowSpan={2} sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>GRADO</TableCell>
              <TableCell align="center" colSpan={columnas.length} sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>ÁREA TEMÁTICA</TableCell>
              <TableCell align="center" rowSpan={2} sx={{ fontWeight: 'bold' }}>TOTAL</TableCell>
            </TableRow>
            <TableRow>
              {columnas.map((col, idx) => (
                <TableCell key={col} align="center" sx={{ fontWeight: 'bold', bgcolor: '#9f9f9f', borderRight: idx === columnas.length - 1 ? '1px solid #e0e0e0' : 'none' }}>
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {niveles.map((nivel, nivelIndex) => {
              let totalNivelPorArea = {};
              columnas.forEach(c => totalNivelPorArea[c] = 0);
              let granTotalNivel = 0;

              return (
                <React.Fragment key={nivel.nombre}>
                  {nivel.grados.map((grado, gradoIndex) => {

                    let totalFilaGrado = 0;

                    return (
                      <TableRow key={`${nivel.nombre}-${grado}`} hover>
                        {nivelIndex === 0 && gradoIndex === 0 && (
                          <TableCell rowSpan={totalFilasTipo} align="center" sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>{tipo}</TableCell>
                        )}
                        {gradoIndex === 0 && (
                          <TableCell rowSpan={nivel.grados.length + 1} align="center" sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>{nivel.nombre}</TableCell>
                        )}

                        <TableCell align="center" sx={{ borderRight: '1px solid #e0e0e0' }}>{grado}</TableCell>

                        {columnas.map((col, idx) => {
                          const valor = obtenerConteo(nivel.nombre, grado, col);
                          totalFilaGrado += valor;
                          totalNivelPorArea[col] += valor;
                          granTotalNivel += valor;

                          return (
                            <TableCell key={col} align="center" sx={{ borderRight: idx === columnas.length - 1 ? '1px solid #e0e0e0' : 'none' }}>
                              {valor}
                            </TableCell>
                          );
                        })}

                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>{totalFilaGrado}</TableCell>
                      </TableRow>
                    );
                  })}

                  <TableRow sx={{ bgcolor: '#fff9c4' }}>
                    <TableCell align="center" sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>TOTAL</TableCell>
                    {columnas.map((col, idx) => (
                      <TableCell key={col} align="center" sx={{ fontWeight: 'bold', borderRight: idx === columnas.length - 1 ? '1px solid #e0e0e0' : 'none' }}>
                        {totalNivelPorArea[col]}
                      </TableCell>
                    ))}
                    <TableCell align="center" sx={{ fontWeight: 'bold', bgcolor: '#ffeb3b' }}>{granTotalNivel}</TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })}

            <TableRow sx={{ bgcolor: '#e3f2fd' }}>
              <TableCell
                align="center"
                colSpan={3}
                sx={{
                  fontWeight: 900,
                  fontSize: '1.05rem',
                  color: '#01579b',
                  borderRight: '1px solid #e0e0e0'
                }}
              >
                TOTAL GENERAL {tipo}
              </TableCell>

              {columnas.map((col, idx) => (
                <TableCell
                  key={`global-${col}`}
                  align="center"
                  sx={{
                    fontWeight: 900,
                    color: '#01579b',
                    borderRight: idx === columnas.length - 1 ? '1px solid #e0e0e0' : 'none'
                  }}
                >
                  {totalesGlobales[col]}
                </TableCell>
              ))}

              <TableCell
                align="center"
                sx={{
                  fontWeight: 900,
                  fontSize: '1.1rem',
                  bgcolor: '#bbdefb',
                  color: '#01579b'
                }}
              >
                {totalAbsoluto}
              </TableCell>
            </TableRow>

          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
